import * as React from "react";

import { IQuestionnaireTabComponent } from "@modules/fhq-design-tool/types/tab-component";
import { QuestionnaireManagementErrors } from "@modules/fhq-design-tool/controllers/questionnaire-validation";
import { Flex } from "@common/components/Flex";

import { Switch } from "../../../switch";
import { TextEdit } from "../../../text-edit";

import "./header.styles.scss";

type HeaderProps = {
  questionnaire: IQuestionnaireTabComponent["questionnaire"];
  onConsentEnable: (enabled: boolean) => void;
  consentEnabled: boolean;
  labelValue: string;
  onLabelChange: (changedValue: string) => void;
  errors?: QuestionnaireManagementErrors;
};

export const Header: React.FC<HeaderProps> = (props) => {
  const { consentEnabled, onConsentEnable, labelValue, onLabelChange, errors } =
    props;

  return (
    <Flex className="FhqDesignToolConsentHeader" alignItems="flex-start">
      <TextEdit
        required
        editable={consentEnabled}
        disabled={!consentEnabled}
        metadata={{
          description: "edit-consent-title",
        }}
        inputWidth={300}
        className="FhqDesignToolConsentHeader__editing"
        value={labelValue}
        onChange={onLabelChange}
        errors={errors?.properties?.consentTitle}
        labelSuffix={
          <Switch
            className="FhqDesignToolConsentHeader__enable-action"
            value={consentEnabled}
            onChange={onConsentEnable}
            classes={{
              labelInputWrapper:
                "FhqDesignToolConsentHeader__editing__label__input__wrapper",
            }}
            metadata={{
              description: "enabled-consent",
            }}
          />
        }
      />
    </Flex>
  );
};
